import { createContext } from 'react';

type ImageViewerContextValue = {
  sources: string[];
};

export const ImageViewerContext = createContext<ImageViewerContextValue>({
  sources: [],
});
